module.exports = __webpack_public_path__ + "img/im_scrollfeature_04@2x.46c4dd62.jpg";